import * as React from 'react';
import { SIDE_NAV_ID } from './side-nav-constants';
import type { ISideNavMobileHeaderProps } from './types';
import { cn } from '@utils';

export const SIDE_NAV_MOBILE_HEADER_HEIGHT_REM = 5.2;

/**
 * Dedicated mobile top bar with glass styling and an open-navigation control.
 */
export const SideNavMobileHeader: React.FC<ISideNavMobileHeaderProps> = ({
	onOpen,
	expanded = false,
	controlsId = SIDE_NAV_ID,
	title,
	'aria-label': ariaLabel,
	icon,
	className,
}) => {
	return (
		<header
			data-testid="side-nav-mobile-header"
			className={cn(
				'fixed inset-x-0 top-0 z-[100] flex h-[5.2rem] items-center gap-[1.2rem] border-b border-black/10',
				'bg-white/80 px-[1.2rem] backdrop-blur-[8px]',
				className
			)}
		>
			<button
				type="button"
				onClick={onOpen}
				aria-label={ariaLabel}
				aria-expanded={expanded}
				aria-controls={controlsId}
				data-testid="side-nav-mobile-header-open"
				className={cn(
					'flex h-[3.2rem] w-[3.2rem] shrink-0 items-center justify-center rounded-[0.8rem]',
					'border border-black/10 bg-white/40 text-black/50',
					'transition-colors hover:bg-white/70 hover:text-black/70',
					'focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-accent'
				)}
			>
				{icon}
			</button>
			{title ? (
				<p
					className="m-0 min-w-0 flex-1 truncate font-sans text-[1.4rem] font-semibold leading-[130%] text-primary"
					data-testid="side-nav-mobile-header-title"
				>
					{title}
				</p>
			) : null}
		</header>
	);
};

SideNavMobileHeader.displayName = 'SideNavMobileHeader';
